<script lang="ts">
	import { Button, ButtonSize, ButtonType, Icon, Tooltip } from '@repo/commons/components'
	import type { UploadedImage } from '@repo/commons/models'

	let {
		uploadedImages = [],
		onRetryUpload = () => {},
		onRemoveImage = () => {}
	}: {
		uploadedImages: UploadedImage[]
		onRetryUpload: (id: string) => void
		onRemoveImage: (id: string) => void
	} = $props()

	const filteredImages = $derived(uploadedImages.filter((img) => img.uploading || img.error))

	const shouldShow = $derived(filteredImages.length > 0)
</script>

{#if shouldShow}
	<div class="upload-progress">
		{#each filteredImages as image}
			<div class="upload-item">
				<div class="upload-item-content">
					<Icon name="image" class={image.error ? 'text-red-500' : 'text-blue-500'} />
					<div class="upload-item-info" class:text-red-500={image.error}>
						<span class="text-sm font-medium flex items-center">
							{image.uploading ? 'Uploading' : 'Failed'}
							{image.file.name}
							{#if image.error}
								<Tooltip text={image.error}>
									<Icon name="info" size="sm" />
								</Tooltip>
							{/if}
						</span>
					</div>
				</div>
				<div class="upload-item-actions">
					{#if image.uploading}
						<div class="loading-spinner"></div>
					{:else if image.error}
						<Button
							buttonType={ButtonType.TERTIARY_INVERSE}
							buttonSize={ButtonSize.SMALL}
							rounded
							iconProps={{ name: 'refreshThin', size: 'md' }}
							onclick={() => onRetryUpload(image.id)}
						/>
						<Button
							buttonType={ButtonType.TERTIARY_INVERSE}
							buttonSize={ButtonSize.SMALL}
							rounded
							iconProps={{ name: 'close', size: 'md' }}
							onclick={() => onRemoveImage(image.id)}
						/>
					{/if}
				</div>
			</div>
		{/each}
	</div>
{/if}

<style>
	.upload-progress {
		@apply p-3 border-t border-[#002C4D80]/20 bg-blue-50;
	}
	.upload-item {
		@apply flex items-center justify-between gap-2 py-1;
	}
	.upload-item-content {
		@apply flex items-center gap-2 flex-1;
	}
	.upload-item-info {
		@apply flex flex-col;
	}
	.upload-item-actions {
		@apply flex items-center gap-1;
	}
	.loading-spinner {
		@apply w-4 h-4 border-2 border-blue-500 border-t-transparent rounded-full animate-spin;
	}
	.retry-btn,
	.remove-btn {
		@apply flex items-center justify-center w-6 h-6 rounded hover:bg-gray-200 transition-colors text-gray-600;
	}
</style>
